/**
 * <revamp-cart-upgrade>
 * "Subscribe & Save" in-cart upgrade for the revamped cart drawer.
 *
 * Converts a one-time cart line to its subscription selling plan IN PLACE
 * (keeping quantity) via POST /cart/change, then re-renders the drawer using the
 * theme's own machinery: it dispatches `cart:bundled-sections` to collect the
 * section ids, requests them back, and publishes the theme `cartUpdate` event so
 * CartItems swaps #MiniCart-<id> exactly as a quantity change would.
 *
 * Guarded so the AJAX section re-render (which re-inserts this script tag but does
 * not re-execute it) never throws "already defined".
 */
if (!customElements.get('revamp-cart-upgrade')) {
  class RevampCartUpgrade extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-revamp-upgrade-button]');
      if (this.button) this.button.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();
      if (this.getAttribute('aria-busy') === 'true') return;

      const line = this.dataset.line;
      const sellingPlan = this.dataset.plan;
      const quantity = parseInt(this.dataset.quantity, 10) || 1;
      if (!line || !sellingPlan) return;

      // Bail out gracefully if the theme runtime isn't present for any reason.
      if (typeof theme === 'undefined' || !theme.routes || !theme.pubsub) return;

      this.setAttribute('aria-busy', 'true');

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const body = JSON.stringify({
        line,
        quantity,
        selling_plan: sellingPlan,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      });

      fetch(`${theme.routes.cart_change_url}`, { ...theme.utils.fetchConfig(), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status) {
            this.fail(parsedState);
            return;
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState, line });
        })
        .catch((error) => this.fail(error));
    }

    fail(payload) {
      this.removeAttribute('aria-busy');
      // eslint-disable-next-line no-console
      console.warn('[revamp-cart-upgrade] could not switch to subscription:', payload && (payload.message || payload.description || payload));
    }
  }

  customElements.define('revamp-cart-upgrade', RevampCartUpgrade);
}
